import { render, staticRenderFns } from "./PagedTableView.vue?vue&type=template&id=6edf3f70&"
import script from "./PagedTableView.vue?vue&type=script&lang=ts&"
export * from "./PagedTableView.vue?vue&type=script&lang=ts&"
import style0 from "./PagedTableView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports